import React from "react";
import {
  Box,
  HStack,
  Text,
  IconButton,
  VStack,
  Collapse,
  useDisclosure,
  Flex,
  Checkbox,
} from "@chakra-ui/react";
import { ChevronDownIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { FolderIcon } from "lucide-react";
import { FileItem } from "./file-item";

interface FolderNodeProps {
  folder: FolderItem;
  selectedFile: DocumentItem | null;
  onSelect: (file: DocumentItem) => void;
}

export const FolderNode: React.FC<FolderNodeProps> = ({
  folder,
  selectedFile,
  onSelect,
}) => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: false });

  return (
    <Box>
      <HStack
        onClick={onToggle}
        _hover={{ bg: "gray.50" }}
        borderRadius="md"
        p={1}
        cursor="pointer"
      >
        <IconButton
          aria-label="toggle folder"
          size="xs"
          variant="ghost"
          icon={isOpen ? <ChevronDownIcon /> : <ChevronRightIcon />}
        />
        <Flex flexDirection="row" justifyContent="space-between" w="100%">
          <Text fontWeight="semibold" color={"#1A1A1A"} fontSize="sm">
            {folder?.name}
          </Text>
          <FolderIcon size={16} color="#1A1A1A" />
        </Flex>
      </HStack>

      <Collapse in={isOpen} animateOpacity>
        <VStack
          align="start"
          pl={8}
          spacing={0}
          maxH="150px"
          overflowY="auto"
          sx={{
            "&::-webkit-scrollbar": { width: "6px" },
            "&::-webkit-scrollbar-thumb": {
              background: "#cbd5e0",
              borderRadius: "4px",
            },
          }}
        >
          {folder?.documents?.map((doc) => (
            <FileItem
              key={doc?.id}
              doc={doc}
              selectedFile={selectedFile}
              onSelect={onSelect}
            />
          ))}
        </VStack>
      </Collapse>
    </Box>
  );
};
